const notificationTypesModel = vm => ({
  title: vm.$gettext('Notification Types'),
  endpoint: 'notification-types',
  allowNew: true,
  shared: true,
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'name',
      label: vm.$gettext('Name'),
      sortable: true,
      editable: true,
      required: true
    },
    {
      key: 'description',
      label: vm.$gettext('Description'),
      sortable: false,
      editable: true,
      description: vm.$gettext('Notification type brief description')
    },
    {
      key: 'media_default',
      label: vm.$gettext('Media Default'),
      sortable: true,
      editable: true,
      required: true,
      description: vm.$gettext(
        'Indicates which media will be used to send the notification as default. Must be one of: email, whatsapp, sms'
      )
    }
  ],
  filters: ['id', 'name', 'media_default']
})

export default notificationTypesModel
